export const getMatchdayNumber = (matchday = {}) => {
  const candidates = [
    matchday.numero,
    matchday.numJornada,
    matchday.jornada,
    matchday.nombre,
  ];

  for (const candidate of candidates) {
    if (candidate == null || candidate === "") continue;
    if (Number.isFinite(Number(candidate))) return Number(candidate);

    const match = String(candidate).match(/\d+/);
    if (match) return Number(match[0]);
  }

  return null;
};

export const getMatchdays = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.jornadas)) return data.jornadas;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export const findMatchday = (data, number) =>
  getMatchdays(data).find(
    (matchday) => getMatchdayNumber(matchday) === Number(number)
  ) ?? null;

export const filterMatchdays = (data, selectedMatchday) => {
  const matchdays = getMatchdays(data);
  if (selectedMatchday === "all") return matchdays;

  return matchdays.filter(
    (matchday) =>
      getMatchdayNumber(matchday) === Number(selectedMatchday)
  );
};

export const getFixtureHighlights = (match, round, standings, finished) => {
  const previousRound = getMatchdayNumber(round) - 1;
  const teams = standings?.find((snapshot) => getMatchdayNumber(snapshot) === previousRound)?.clasificacion;
  if (!Array.isArray(teams)) return [];
  const rank = (id) => {
    if (id == null) return null;
    const index = teams.findIndex((team) => team.codequipo != null && String(team.codequipo) === String(id));
    if (index < 0) return null;
    const value = teams[index].posicion == null ? index + 1 : Number(teams[index].posicion);
    return Number.isInteger(value) && value >= 1 && value <= teams.length ? value : null;
  };
  const home = rank(match.codEquipoLocal ?? match.idEquipoLocal);
  const away = rank(match.codEquipoVisitante ?? match.idEquipoVisitante);
  if (home === null || away === null) return [];
  if (Math.min(home, away) === 1 && Math.max(home, away) === 2) {
    return [{ type: 'titleDuel', home, away, round: previousRound }];
  }
  const quarter = Math.ceil(teams.length / 4);
  if (!finished || teams.length < 4 || Math.min(home, away) > quarter ||
    Math.max(home, away) <= teams.length - quarter) return [];
  if (![match.golesCasa, match.golesVisitante].every((value) =>
    (typeof value === 'number' || typeof value === 'string') && String(value).trim() !== '' &&
    Number.isInteger(Number(value)) && Number(value) >= 0)) return [];
  const homeIsLower = home > away;
  const lowerScore = Number(homeIsLower ? match.golesCasa : match.golesVisitante);
  const higherScore = Number(homeIsLower ? match.golesVisitante : match.golesCasa);
  if (lowerScore < higherScore) return [];
  return [{
    type: 'surprise', result: lowerScore > higherScore ? 'win' : 'draw',
    lower: Math.max(home, away), higher: Math.min(home, away), round: previousRound,
  }];
};
